import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { CASE_API } from './cases/api/case-api.token';
import { HttpCaseApiService } from './cases/api/http-case-api.service';
import { OPTION_API } from './options/api/option-api.token';
import { HttpOptionApiService } from './options/api/http-option-api.service';
import { HttpOptionReferenceService } from './options/reference/http-option-reference.service';
import { OPTION_REFERENCE_API } from './options/reference/option-reference-api.token';
import { ACTION_API } from './actions/api/action-api.token';
import { HttpActionApiService } from './actions/api/http-action-api.service';
import { ACTION_REFERENCE_API } from './actions/reference/action-reference-api.token';
import { HttpActionReferenceService } from './actions/reference/http-action-reference.service';
import { ACTION_OWNER_API } from './actions/owners/action-owner-api.token';
import { EmployeeSearchActionOwnerService } from './actions/owners/employee-search-action-owner.service';
import { DialogService } from 'primeng/dynamicdialog';
import { ActionModalService } from './actions/action-modal.service';

import { OUTCOME_API } from './outcomes/api/outcome-api.token';
import { HttpOutcomeApiService } from './outcomes/api/http-outcome-api.service';
import { GOAL_API } from './goals/api/goal-api.token';
import { HttpGoalApiService } from './goals/api/http-goal-api.service';

/**
 * Registers Care Plan providers at the app root.
 *
 * `CarePlanStore` remains scoped per panel. The root provider registers the
 * live AIM Goal, Case, Option, Action, Outcome, Matrix, and System Code APIs without
 * making presentation state a singleton. Action catalogs use the live System
 * Codes API. Existing human-FA ownership is resolved through the shared
 * employee search; creation ownership is derived by AIM from Okta.
 */
export function provideCarePlan(): EnvironmentProviders {
  return makeEnvironmentProviders([
    HttpGoalApiService,
    { provide: GOAL_API, useExisting: HttpGoalApiService },
    HttpOutcomeApiService,
    { provide: OUTCOME_API, useExisting: HttpOutcomeApiService },
    HttpCaseApiService,
    {
      provide: CASE_API,
      useExisting: HttpCaseApiService,
    },
    HttpOptionApiService,
    {
      provide: OPTION_API,
      useExisting: HttpOptionApiService,
    },
    HttpOptionReferenceService,
    {
      provide: OPTION_REFERENCE_API,
      useExisting: HttpOptionReferenceService,
    },
    HttpActionApiService,
    {
      provide: ACTION_API,
      useExisting: HttpActionApiService,
    },
    HttpActionReferenceService,
    {
      provide: ACTION_REFERENCE_API,
      useExisting: HttpActionReferenceService,
    },
    EmployeeSearchActionOwnerService,
    {
      provide: ACTION_OWNER_API,
      useExisting: EmployeeSearchActionOwnerService,
    },
    DialogService,
    ActionModalService,
  ]);
}
